import { PAYLOAD_STATUS_REJECTED } from "routes/audit/lib/audit-constants.mjs"
import { getReviewDecisionAmendsKey } from "./review-decision-amends-key"

// A rejection is "valid" if it hasn't been superseded by a later approval of the same change.
// For each amendsKey, only its most recent prior decision matters: an approval means nothing
// earlier can be surfaced, a rejection is the one to show. Cycles with no decision for that key
// are absent from the grouped map entirely, so the most recent entry is always decisive.
export function resolveRejectionsByAmendsKey({ amends = [], reviewCycle, scheduleId } = {}) {
    const rejections = {}
    if (!scheduleId) return rejections

    const latestDecisionByAmendsKey = groupLatestPriorDecisionByAmendsKey({ amends, reviewCycle, scheduleId })

    for (const [amendsKey, decision] of latestDecisionByAmendsKey) {
        if (decision?.payload?.status === PAYLOAD_STATUS_REJECTED) rejections[amendsKey] = decision
    }

    return rejections
}

function groupLatestPriorDecisionByAmendsKey({ amends, reviewCycle, scheduleId }) {
    const cycleByAmendsKey = new Map()
    const decisionByAmendsKey = new Map()

    for (const amend of amends ?? []) {
        const amendCycle = Number(amend?.payload?.reviewCycle)
        if (amendCycle >= reviewCycle) continue

        const amendsKey = getReviewDecisionAmendsKey(amend, scheduleId)
        if (!amendsKey) continue

        if (cycleByAmendsKey.has(amendsKey) && cycleByAmendsKey.get(amendsKey) >= amendCycle) continue
        cycleByAmendsKey.set(amendsKey, amendCycle)
        decisionByAmendsKey.set(amendsKey, amend)
    }

    return decisionByAmendsKey
}
